import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';

import { FormlyFieldBaseComponent } from '../formly-field-base.component';

@Component({
  selector: 'app-formly-radio',
  templateUrl: './formly-radio.component.html',
  styleUrl: './formly-radio.component.scss',
  imports: [FormsModule, ReactiveFormsModule, FormlyModule],
})
export class FormlyRadioComponent extends FormlyFieldBaseComponent {}
